// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import CryptoJS from 'crypto-js';

Vue.config.productionTip = false

Vue.prototype.WEBCONF = {
    url: "https://app.wujieqh.com/",
};

/**
     * 将字符串转换成unicode代码用于签名
     */
     function Utf8ToUnicode(strUtf8) {
         var i,j;
	var uCode;
	var temp = new Array();
	for(i=0,j=0; i<strUtf8.length; i++){
		uCode = strUtf8.charCodeAt(i);
		if(uCode<0x100){					//ASCII字符
			temp[j++] = 0x00;
			temp[j++] = uCode;
		}else if(uCode<0x10000){
			temp[j++] = (uCode>>8)&0xff;
			temp[j++] = uCode&0xff;
		}else if(uCode<0x1000000){
			temp[j++] = (uCode>>16)&0xff;
			temp[j++] = (uCode>>8)&0xff;
			temp[j++] = uCode&0xff;
		}else if(uCode<0x100000000){
			temp[j++] = (uCode>>24)&0xff;
			temp[j++] = (uCode>>16)&0xff;
			temp[j++] = (uCode>>8)&0xff;
			temp[j++] = uCode&0xff;
		}else{
			break;
		}
	}
	temp.length = j;
	return temp;
}
     
function stringToArrayBuffer(str) {
  let decString = [];
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i);
      decString.push(charCode);
  }
  return Buffer.from(decString);
}

    /**
     * 生成签名
     * @method checkSig
     */
     Vue.prototype.checkSig = function (params) {
             let keys = [];
        for (let key in params) {
                            keys.push(key);
        } // for
                keys.sort();
        let srcs = [];
        for (let key of keys) {
                srcs.push(key + '=' + params[key]);
        }
        let src = srcs.join('&')
                                //const sig = crypto.createHmac('sha1', secret).update(stringToArrayBuffer(src)).digest('base64');
                                // hmac sha1 secret
const secret = 'AdfvxZT4wxbBFS5dbNGT4xDFG';
     const hmac = CryptoJS.HmacSHA1(src, secret);
                                const sig = CryptoJS.enc.Base64.stringify(hmac);
                                console.log('src:',src,'sig:',sig)
                                                        return encodeURIComponent(sig)
    }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js